<template>
  <div id="app" :class="{ 'app-login': isLoginPage }">
    <div class="app-stage-shell" :style="stageShellStyle">
      <div class="app-stage">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
const DESIGN_WIDTH = 1920;
const DESIGN_HEIGHT = 1080;

window.forceWebGL = true;
export default {
  name: "App",
  data() {
    return {
      stageScale: 1,
      stageWidth: DESIGN_WIDTH,
      stageHeight: DESIGN_HEIGHT,
      resizeFrame: null,
    };
  },
  computed: {
    isLoginPage() {
      return this.$route && this.$route.path === "/login";
    },
    stageShellStyle() {
      if (this.isLoginPage) {
        return {
          width: "100%",
          height: "100%",
          transform: "none",
        };
      }

      return {
        width: `${this.stageWidth}px`,
        height: `${this.stageHeight}px`,
        transform: `scale(${this.stageScale})`,
      };
    },
  },
  mounted() {
    this.bindScaleEvents();
    this.updateStageScale();
  },
  beforeDestroy() {
    this.unbindScaleEvents();
    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = null;
    }
  },
  methods: {
    bindScaleEvents() {
      window.addEventListener("resize", this.scheduleScaleUpdate, {
        passive: true,
      });
      window.addEventListener("orientationchange", this.scheduleScaleUpdate, {
        passive: true,
      });
      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          "resize",
          this.scheduleScaleUpdate,
          { passive: true },
        );
        window.visualViewport.addEventListener(
          "scroll",
          this.scheduleScaleUpdate,
          { passive: true },
        );
      }
    },
    unbindScaleEvents() {
      window.removeEventListener("resize", this.scheduleScaleUpdate);
      window.removeEventListener("orientationchange", this.scheduleScaleUpdate);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          this.scheduleScaleUpdate,
        );
        window.visualViewport.removeEventListener(
          "scroll",
          this.scheduleScaleUpdate,
        );
      }
    },
    scheduleScaleUpdate() {
      if (this.resizeFrame) {
        return;
      }
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.updateStageScale();
      });
    },
    getViewportSize() {
      if (window.visualViewport) {
        return {
          width: window.visualViewport.width,
          height: window.visualViewport.height,
        };
      }
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
    updateStageScale() {
      const { width, height } = this.getViewportSize();
      if (!width || !height) {
        return;
      }

      const rawScale = Math.min(width / DESIGN_WIDTH, height / DESIGN_HEIGHT);
      const safeScale =
        Number.isFinite(rawScale) && rawScale > 0 ? rawScale : 1;
      const stageWidth = Math.max(DESIGN_WIDTH, width / safeScale);
      const stageHeight = Math.max(DESIGN_HEIGHT, height / safeScale);

      this.stageScale = safeScale;
      this.stageWidth = stageWidth;
      this.stageHeight = stageHeight;

      const rootStyle = document.documentElement.style;
      rootStyle.setProperty("--app-scale", String(safeScale));
      rootStyle.setProperty("--app-width", `${stageWidth}px`);
      rootStyle.setProperty("--app-height", `${stageHeight}px`);
      rootStyle.setProperty("--app-vw", `${stageWidth / 100}px`);
      rootStyle.setProperty("--app-vh", `${stageHeight / 100}px`);
      rootStyle.setProperty("--viewport-width", `${width}px`);
      rootStyle.setProperty("--viewport-height", `${height}px`);

      this.$nextTick(() => {
        window.dispatchEvent(
          new CustomEvent("app-stage-resize", {
            detail: {
              scale: safeScale,
              width: stageWidth,
              height: stageHeight,
              viewportWidth: width,
              viewportHeight: height,
            },
          }),
        );
      });
    },
  },
};
</script>
<style>
:root {
  --app-scale: 1;
  --app-width: 1920px;
  --app-height: 1080px;
  --app-vw: 19.2px;
  --app-vh: 10.8px;
}
*,html,body{
  margin: 0;
  padding:0;
}
html { scroll-behavior: smooth; }
html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app{
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: #101818;
}
#app.app-login {
  background:
    linear-gradient(90deg, rgba(241, 248, 248, 0.72) 0%, rgba(247, 251, 251, 0.42) 22%, rgba(247, 251, 251, 0.2) 50%, rgba(239, 249, 248, 0.48) 100%),
    url("./assets/login/bg2.png") center center / cover no-repeat,
    #f8fbfb;
}
.app-stage-shell {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: left top;
  will-change: transform;
}
.app-stage {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.amap-logo{
  display: none !important;
}
.amap-copyright{
  display: none !important;
}
.el-dialog__header{
  background: #363939;
  border-bottom: 1px solid #4F5656;
}
.el-dialog__body{
  background: #363939;
}
.el-dialog__title{
  color: #FFFFFF;
}
.el-message-box{
  background: #363939;
  border: none;
}
.el-message-box__title{
  color:#ffffff;
}
.el-message-box__message{
  color:#ffffff;
}
.el-message-box > .el-message-box__btns > .el-button {
   background: #363939;
   color:#DFDFDF;
   border: 1px solid #4F5656;
}
.el-message-box > .el-message-box__btns >.el-button--primary {
  background:#31F1CA;
  color:#111111;
}
.el-table, .el-table__expanded-cell{
  background: none;
}
.custom-marker-car5{
  width:30px;
  height:42px;
  background: url("./assets/home/dr5.png") no-repeat;
  background-position: center;
  background-size: 30px 42px ;
}
.custom-marker-car5 > span {
  font-size:12px;
}

.custom-marker-car3{
  width:30px;
  height:42px;
  background: url("./assets/home/cr3.png") no-repeat;
  background-position: center;
  background-size:30px 42px;
}

.custom-marker-car3 > span {
  font-size:12px;
}

.amap-container {
  background-image: none;
}

.el-select-dropdown{
  background-color: #2B2F2F;
  border:#2B2F2F 1px solid;
  color:#fff;
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
  background-color: #27423C;
}

.el-dropdown-menu{
  background-color:#131D1D;
  border:1px solid #31F1CA;
}

.el-popper .popper__arrow, .el-popper .popper__arrow::after{
    border-style:none;
}

.el-table-filter {
    background-color: #373C3C !important;
    border: #373C3C solid 1px;
    color: #373C3C;
}

.el-checkbox {
  color:#DFDFDF;
}

.el-checkbox__input.is-checked+.el-checkbox__label{
  color:#DFDFDF;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
   background-color:#31F1CA;
   border-color:#31F1CA;
}

.el-table th.el-table__cell>.cell.highlight{
  color: #fff;
}
.el-table-filter__bottom button {
  color:#31F1CA;
}

.el-table-filter__bottom button:hover{
  color:#31F1CA;
}

.el-table-filter__bottom .is-disabled:hover{
  color:#C0C4CC;
}

.el-table__column-filter-trigger i {
  font-size: 14px;
  color:#fff;
}

.el-cascader__dropdown{
  background-color: #2B2F2F;
  border: #2B2F2F solid 1px;
}

.el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover {
  background-color: #3D4141;
}

.el-cascader-menu {
  color:#fff;
  border-right: #434848 1px solid;
}

.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
   color:#31F1CA;
}

.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  border:#667171 1px solid;
}

.el-checkbox__inner::after{
    box-sizing: content-box;
    content: "";
    border: 1px solid #434848;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform .15s ease-in .05s;
    transform-origin: center;
}
.el-table-filter__bottom {
    border-top: #667171 1px solid;
    padding: 8px;
}

.el-radio__input.is-checked .el-radio__inner {
  background-color: #31F1CA;
  border:#31F1CA;
}

.el-radio__inner{
     background-color: #2B2F2F;
     border: 1px solid #667171;
}
.el-radio__inner::after{
    background-color: #31F1CA;
}
.el-radio__inner:hover {
  border:#31F1CA;
}

.el-message-box .el-input__inner {
    background-color: #131D1D;
    border: 1px solid #414747;
    color: #fff;
}

.el-dialog__wrapper .el-input__inner {
    background-color: #131D1D;
    border: 1px solid #4D5E5E;
    color: #fff;
}
.el-dialog__wrapper .el-dialog__header {
   padding: 0;
   border:none;
}
.el-textarea__inner {
  background-color: #131D1D;
  border: 1px solid #4D5E5E;
  color: #fff;
}
</style>
